import React from 'react';
import { Button, TouristsPicker } from '@lt/components';
import cn from 'classnames';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';

import Icon from '../../../../../components/Icon';
import SearchParamsItem from './SearchParamsItem';
import SearchParamsKids from './SearchParamsKids';
import SearchParamsLabel from './SearchParamsLabel';
import SearchParamsControl from './SearchParamsControl';

const baseCls = 'checkout-shortinfo';
const searcherCls = 'checkout-searcher';

interface SearchParamsTouristsProps {
  adults: number;
  kids?: number[];
  isMobile?: boolean;
  onChangeAdults: (value: number) => void;
  onChangeKids: (kidValue: number[]) => void;
  onClear: () => void;
  onSubmit: () => void;
  hasAdjustParams?: boolean;
  isHotelOnly: boolean;
  isArchived: boolean;
}

const SearchParamsTourists = ({
  adults,
  kids = [],
  isMobile,
  onChangeAdults,
  onChangeKids,
  hasAdjustParams,
  onClear,
  onSubmit,
  isHotelOnly,
  isArchived,
}: SearchParamsTouristsProps) => {
  const { t } = useTranslation();
  const CustomControl = isMobile
    ? SearchParamsControlMobile
    : SearchParamsControl;
  const CustomLabel = () => (
    <SearchParamsLabel label={t('checkout.tourists.search.label')} />
  );

  return (
    <SearchParamsItem name="tourists" border={!isMobile}>
      <div className="flex">
        <ul className="checkout-shortinfo-tourists">
          <li className={`${baseCls}-tourists__item`}>
            <div className="like-h2 relative">
              {adults}
              <Icon className={`${baseCls}-item__icon`} type="man" />
            </div>
            <span className="capitalize">
              {t('checkout.tourists.search.adult')}
            </span>
          </li>

          <SearchParamsKids
            kids={kids}
            baseCls={baseCls}
            hasAdjustParams={hasAdjustParams}
            isMobile={isMobile}
          />
        </ul>

        {!isArchived && (
          <div
            className={cn(`${searcherCls}__buttons`, {
              [`${searcherCls}__buttons--hidden`]: !hasAdjustParams,
            })}
          >
            <Button
              functional
              onClick={onClear}
              className={`${searcherCls}__cancel lt-link`}
            >
              {t('subscribe.header.cancel')}
            </Button>

            <Button
              primary
              onClick={onSubmit}
              className={`${searcherCls}__submit lt-button-link`}
            >
              {t('hotel.cigarette.buttonSearch')}
            </Button>
          </div>
        )}
      </div>

      {!isArchived && !isHotelOnly ? (
        <StyledWrapper>
          <TouristsPicker
            adultsValue={adults}
            kidsValue={kids}
            onChangeAdults={onChangeAdults}
            onChangeKids={onChangeKids}
            isMobile={isMobile}
            CustomControl={CustomControl}
            CustomLabel={CustomLabel}
          />
        </StyledWrapper>
      ) : null}
    </SearchParamsItem>
  );
};

const SearchParamsControlMobile = () => {
  const { t } = useTranslation();
  return <StyledButton>{t('checkout.tourists.search.label')}</StyledButton>;
};

const StyledButton = styled.div`
  display: flex;
  align-items: center;
  color: #007aff;

  &:hover {
    cursor: pointer;
  }
`;

const StyledWrapper = styled.div`
  position: absolute;

  .react-select__control {
    height: 17px;
    min-height: 17px;
  }

  .react-select__value-container {
    padding-left: 0;
    display: flex;
  }

  .react-select__menu {
    color: #000 !important;
    font-weight: 400 !important;
    opacity: 1;
  }
`;

export default SearchParamsTourists;
